"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProviderMergingLogic = exports.createProviders = void 0;
/* eslint-disable react-hooks/rules-of-hooks */

var react_flexible_contexts_1 = require("react-flexible-contexts");

var objects_1 = require("../utils/objects");

var react_1 = require("react");

var weak_map_1 = require("../utils/weak-map");

var flags_1 = require("../flags");

exports.createProviders = function (_a) {
  var defaultValue = _a.defaultValue,
      defaultMergeFlags = _a.defaultMergeFlags,
      _b = _a.layerTransformationHook,
      layerTransformationHook = _b === void 0 ? function (x) {
    return x;
  } : _b,
      contextDisplayName = _a.contextDisplayName,
      rawToFinalValueHook = _a.rawToFinalValueHook,
      mergeDecisionFn = _a.mergeDecisionFn;
  var memoContainer = new weak_map_1.MultiDimentionalWeakMap(4);
  var contextDrfaultValue = defaultValue === undefined ? undefined : {
    mergeFlags: defaultMergeFlags !== null && defaultMergeFlags !== void 0 ? defaultMergeFlags : [],
    value: defaultValue
  };
  var Container = react_flexible_contexts_1.StackedContext.create(contextDrfaultValue, {
    rawToFinalValueHook: rawToFinalValueHook
  });

  if (contextDisplayName) {
    Container.context.setContextName(contextDisplayName);
  }

  var FullValueProvider = Container.context.Provider;
  var FullNonMergingProvider = Container.addProvider(wrapInMeta(layerTransformationHook, function () {
    return {
      mergeFlags: undefined
    };
  })); // merges everything

  var PartialMergingProvider = Container.addProvider(exports.createProviderMergingLogic({
    transformationHook: layerTransformationHook,
    memoContainer: memoContainer,
    mergeDecisionFn: mergeDecisionFn
  })); // merges everything except default value

  var PartialNonPackageMergingProvider = Container.addProvider(exports.createProviderMergingLogic({
    transformationHook: layerTransformationHook,
    memoContainer: memoContainer,
    avoidPackageCustoMerging: true,
    mergeDecisionFn: mergeDecisionFn
  }));
  window.mergingMemoContainer = memoContainer; // does not merge anything

  var PartialNonMergingProvider = Container.addProvider(exports.createProviderMergingLogic({
    transformationHook: layerTransformationHook,
    memoContainer: memoContainer,
    avoidNonPackageCustoMerging: true,
    avoidPackageCustoMerging: true,
    mergeDecisionFn: mergeDecisionFn
  }));
  return {
    Container: Container,
    FullValueProvider: FullValueProvider,
    FullNonMergingProvider: FullNonMergingProvider,
    PartialMergingProvider: PartialMergingProvider,
    PartialNonPackageMergingProvider: PartialNonPackageMergingProvider,
    PartialNonMergingProvider: PartialNonMergingProvider,
    memoContainer: memoContainer
  };
};

exports.createProviderMergingLogic = function (_a) {
  var _b = _a.transformationHook,
      transformationHook = _b === void 0 ? function (x) {
    return x;
  } : _b,
      _c = _a.memoContainer,
      memoContainer = _c === void 0 ? new weak_map_1.MultiDimentionalWeakMap(4) : _c,
      avoidNonPackageCustoMerging = _a.avoidNonPackageCustoMerging,
      avoidPackageCustoMerging = _a.avoidPackageCustoMerging,
      defaultMergingFlags = _a.mergeFlags,
      mergeDecisionFn = _a.mergeDecisionFn;
  var avoidCustomizationsMerging = false;

  if (avoidNonPackageCustoMerging && avoidPackageCustoMerging) {
    avoidCustomizationsMerging = true;
  }

  var mergeFlags = __spread(defaultMergingFlags || []);

  if (avoidNonPackageCustoMerging) {
    mergeFlags.push(flags_1.CustoMergeFlagEnum.avoidWithNonPackageValue);
  }

  if (avoidPackageCustoMerging) {
    mergeFlags.push(flags_1.CustoMergeFlagEnum.avoidWithPackageDefaultValue);
  }

  var getCurrentMetaHook = function getCurrentMetaHook(customizations, prevMeta) {
    return {
      mergeFlags: mergeFlags
    };
  };

  var fn = function fn(customizations, prevVal, mergedMeta) {
    var transformed = transformationHook(customizations);
    var mergeFlags = mergedMeta.mergeFlags;
    var b = react_1.useMemo(function () {
      return objects_1.mergeCustomizations({
        object1: transformed,
        object2: prevVal,
        memoContainer: memoContainer,
        mergeStrategy: "overrideLeftToRight",
        avoidCustomizationsMerging: avoidCustomizationsMerging,
        mergeFlags: mergeFlags,
        decisionFn: mergeDecisionFn
      });
    }, [transformed, prevVal]);
    return b;
  };

  return wrapInMeta(fn, getCurrentMetaHook);
};

var wrapInMeta = function wrapInMeta(getValueHook, getCurrentMetaHook) {
  return function (currentVal, prevValWithMeta) {
    var currentMeta = getCurrentMetaHook(currentVal, prevValWithMeta.mergeFlags);
    var mergeFlags = react_1.useMemo(function () {
      return new Set(__spread(currentMeta.mergeFlags || [], prevValWithMeta.mergeFlags || []));
    }, [currentMeta, prevValWithMeta.mergeFlags]);
    var mergedMeta = react_1.useMemo(function () {
      return {
        mergeFlags: mergeFlags
      };
    }, [mergeFlags]);
    var value = getValueHook(currentVal, prevValWithMeta.value, mergedMeta);
    return react_1.useMemo(function () {
      return __assign({
        value: value
      }, mergedMeta);
    }, [mergedMeta, value]);
  };
};